<div id="toperror"></div>
<div class="session-wrapper" *ngIf="emPesquisa">
    <div class="container container-full-width">
        <div class="row">
            <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
                <div class="thankyou-wrap">
                    <div class="card border-0 border-rad card-shadow p-4 w-65 mx-auto card-hover">
                        <div class="social-without-bg mb-4">
                            <div class="form-group mb-4" *ngIf="erroresposta.length > 0">
                                <div class="alert alert-danger" role="alert" style="font-size: 14px;">
                                    {{erroresposta}}
                                </div>
                            </div>
                            <form [formGroup]="formGroup" *ngIf="erroresposta.length === 0">
                                <div class="form-group mb-4" *ngIf="erromessage.length > 0">
                                    <div class="alert alert-danger" role="alert">
                                        {{erromessage}}
                                    </div>
                                </div>
                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>1 - Qual o seu vínculo com a Derminas?
                                        </p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_PARTICIPANTE"
                                                    name="tipoParticipante" value="PARTICIPANTE" type="radio"
                                                    formControlName="tipoParticipante">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Participante (Funcionário ou
                                                    aposentado do DER/MG)</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_PENSIONISTA"
                                                    name="tipoParticipante" value="PENSIONISTA" type="radio"
                                                    formControlName="tipoParticipante">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Pensionista</span>
                                            </label>
                                        </div>
                                    </div>
                                    <p>
                                        <small class="text-muted"
                                            *ngIf="formGroup.get('tipoParticipante').hasError('selecionarOpcao')"><span
                                                style="color: red;">Selecione uma resposta.</span></small>
                                    </p>
                                </div>

                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>2 - Qual foi o motivo do seu acesso ao site da Derminas?</p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_1" name="resposta1"
                                                    [value]="1" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Alteração cadastral</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_2" name="resposta1"
                                                    [value]="2" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Consulta empréstimo</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_3" name="resposta1"
                                                    [value]="3" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Contracheques</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_4" name="resposta1"
                                                    [value]="4" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Informações
                                                    institucionais</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_5" name="resposta1"
                                                    [value]="5" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Documentos para requerer
                                                    benefícios</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_6" name="resposta1"
                                                    [value]="6" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Documentos para solicitar
                                                    empréstimos</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_7" name="resposta1"
                                                    [value]="7" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Educação financeira</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_8" name="resposta1"
                                                    [value]="8" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Informativo</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_9" name="resposta1"
                                                    [value]="9" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Informe de rendimentos</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_10" name="resposta1"
                                                    [value]="10" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Recadastramento anual</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_11" name="resposta1"
                                                    [value]="11" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Simulação de empréstimos</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_12" name="resposta1"
                                                    [value]="12" type="radio" formControlName="resposta1" (change)="respostaOutro($event.target.value)">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Outro</span>
                                            </label>
                                        </div>
                                        <div class="form-group mb-4" *ngIf="escolheuOutro">
                                            <input id="perguntaV2Resposta1" type="text" class="form-control"
                                                placeholder="Cite aqui..." maxlength="200"
                                                formControlName="pergunta1Outro">
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta1').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>
                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>3 - Você achou o que precisava?
                                        </p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_13" name="resposta2"
                                                    [value]="1" type="radio" formControlName="resposta2">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Sim, tudo.</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_14" name="resposta2"
                                                    [value]="2" type="radio" formControlName="resposta2">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Sim, uma parte.</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_15" name="resposta2"
                                                    [value]="3" type="radio" formControlName="resposta2">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Não, nada.</span>
                                            </label>
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta2').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>4 - Se você não encontrou o que precisava, diga-nos quais informações você
                                            estava procurando:</p>
                                        <textarea id="pergunta3" class="form-control" rows="5" maxlength="1495"
                                            formControlName="pergunta3"></textarea>
                                    </div>
                                </div>
                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>5 - É fácil achar informações no site?</p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_16" name="resposta4"
                                                    [value]="1" type="radio" formControlName="resposta4">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito fácil</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_17" name="resposta4"
                                                    [value]="2" type="radio" formControlName="resposta4">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Fácil</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_18" name="resposta4"
                                                    [value]="3" type="radio" formControlName="resposta4">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Medianamente fácil</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_19" name="resposta4"
                                                    [value]="4" type="radio" formControlName="resposta4">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Difícil</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_20" name="resposta4"
                                                    [value]="5" type="radio" formControlName="resposta4">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito Difícil</span>
                                            </label>
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta4').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>6 - Adicione seus comentários para melhoria do site:</p>
                                        <textarea id="pergunta5" class="form-control" rows="5" maxlength="1495"
                                            formControlName="pergunta5"></textarea>
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>7 - Com relação ao seu grau de satisfação com o site da Derminas, você está:
                                        </p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_21" name="resposta6"
                                                    [value]="5" type="radio" formControlName="resposta6">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito satisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_22" name="resposta6"
                                                    [value]="4" type="radio" formControlName="resposta6">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Satisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_23" name="resposta6"
                                                    [value]="3" type="radio" formControlName="resposta6">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Indiferente</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_24" name="resposta6"
                                                    [value]="2" type="radio" formControlName="resposta6">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Insatisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_25" name="resposta6"
                                                    [value]="1" type="radio" formControlName="resposta6">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito insatisfeito</span>
                                            </label>
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta6').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>


                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>8 - Com relação ao seu grau de conhecimento sobre o mercado financeiro e os
                                            investimentos da Derminas, você está?
                                        </p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_26" name="resposta7"
                                                    [value]="5" type="radio" formControlName="resposta7">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito satisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_27" name="resposta7"
                                                    [value]="4" type="radio" formControlName="resposta7">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Satisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_28" name="resposta7"
                                                    [value]="3" type="radio" formControlName="resposta7">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Indiferente</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_29" name="resposta7"
                                                    [value]="2" type="radio" formControlName="resposta7">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Insatisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_30" name="resposta7"
                                                    [value]="1" type="radio" formControlName="resposta7">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito insatisfeito</span>
                                            </label>
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta7').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>9 - De forma geral, quão satisfeito você está com seus hábitos financeiros?
                                        </p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_31" name="resposta8"
                                                    [value]="5" type="radio" formControlName="resposta8">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito satisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_32" name="resposta8"
                                                    [value]="4" type="radio" formControlName="resposta8">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Satisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_33" name="resposta8"
                                                    [value]="3" type="radio" formControlName="resposta8">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Indiferente</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_34" name="resposta8"
                                                    [value]="2" type="radio" formControlName="resposta8">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Insatisfeito</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_35" name="resposta8"
                                                    [value]="1" type="radio" formControlName="resposta8">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Muito insatisfeito</span>
                                            </label>
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta8').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>

                                <div class="form-group mb-4">
                                    <div class="check-payment">
                                        <p>10 - Você faz poupança/investe pensando no seu futuro?
                                        </p>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_36" name="resposta9"
                                                    [value]="1" type="radio" formControlName="resposta9">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Sim, me preocupo e planejo meu
                                                    futuro</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_37" name="resposta9"
                                                    [value]="2" type="radio" formControlName="resposta9">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Um pouco, as vezes
                                                    poupo/invisto, mas gasto quando preciso</span>
                                            </label>
                                        </div>
                                        <div class="mb-3">
                                            <label class="custom-control custom-radio mb-0">
                                                <input class="custom-control-input" id="radioV2_38" name="resposta9"
                                                    [value]="3" type="radio" formControlName="resposta9">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Não, não sobra para
                                                    poupar/investir</span>
                                            </label>
                                        </div>
                                        <p>
                                            <small class="text-muted"
                                                *ngIf="formGroup.get('resposta9').hasError('selecionarOpcao')"><span
                                                    style="color: red;">Selecione uma resposta.</span></small>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <button class="btn btn-primary mr-2 mb-2 mb-md-0" type="button" [disabled]="inSpinner"
                            (click)="salvar()" placement="top" ngbTooltip="Salvar" *ngIf="erroresposta.length === 0">
                            <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="inSpinner"></i>
                            <span class="fa fa-save" *ngIf="!inSpinner"></span>
                            {{inSpinner ? 'Aguarde...' : 'Salvar'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="session-wrapper" *ngIf="!emPesquisa">
    <div class="container container-full-width">
        <div class="row">
            <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
                <div class="thankyou-wrap">
                    <div class="card text-white border-rad shadow-md border-0">
                        <img class="card-img img-fluid" src="assets/img/thankyou.png" alt="Card image" width="600"
                            height="300" />
                        <div class="card-img-overlay border-rad">
                            <div class="text-center">
                                <h2 class="ty-card-title fw-200">Muito Obrigado!</h2>
                            </div>
                        </div>
                    </div>
                    <div class="card border-0 border-rad card-shadow p-4 text-center w-65 mx-auto card-hover">
                        <h2 class="font-2x mb-4">Sua opinião é muito importante para nós.</h2>
                        <!-- <p class="text-muted font-sm border-style">Spread The Word</p> -->
                        <div class="social-without-bg mb-4">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item"><a
                                        (click)="abrirLink('https://www.facebook.com/derminasseguridade')"
                                        style="cursor: pointer;"><i class="fa fa-facebook" target="_blank"></i></a></li>
                                <li class="list-inline-item"><a (click)="abrirLink('https://x.com/derminas1')"
                                        style="cursor: pointer;"><i class="fa fa-twitter" target="_blank"></i></a></li>
                            </ul>
                        </div>
                        <a routerLink="/home" class="btn btn-primary btn-block submit-btn btn-lg">Ir para o site</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>